

/**
 * @param {boolean} donorListIsPopulated 
 * @return {void}
 */
function pushDonorListIsPopulated(donorListIsPopulated) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': 'GADonorSearch',
		'donorCardFound': donorListIsPopulated,
	});
}


export { pushDonorListIsPopulated }; 
